import axios from 'axios';
// import JSONbig from 'json-bigint';
let $axios = axios.create({
    timeout: 3000
})
export default {
    loginoutTime: 0,
    $axios (obj) {
        // obj.transformResponse = [function (data) {
        //     return JSONbig.parse(data);
        // }];
        let map = obj.headers || {};
        obj.projectType = obj.projectType || '';
        obj.headers = Object.assign({}, {
            Authorization: localStorage.getItem('token') || ''
        }, map);
        if (['user/login'].includes(obj.url)) {
            delete obj.headers.Authorization;
        }
        $axios.defaults.timeout = obj.timeout || 45000;
        $axios.defaults.withCredentials = true;
        if (obj.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
            obj.transformRequest = [function (data) {
                let str = '';
                for (let k in data) {
                    str += encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) + '&';
                }
                return str;
            }];
        };
        axios.interceptors.request.use((config) => {
            config.withCredentials = true;
            return config;
        }, (err) => {
            return Promise.reject(err);
        });
        axios.interceptors.response.use((response) => {
            return response;
        }, (err) => {
            return Promise.reject(err);
        });
        let api = axios(obj).then((res) => {
            if (res.data.code !== '200' && res.data.message) {
                Message.warning(res.data.message);
            }
            return res;
        }).catch((err) => {
            let s = err.message.indexOf('timeout') > -1 ? '系统繁忙，请求超时，请重试' : '系统繁忙，请重试';
            if (err.response.data && err.response.data.message) {
                s = err.response.data.message;
            }
            if (err.response.data && ['402001', '402021'].includes(err.response.data.code)) {
                let str = '';
                for (let k in obj.query) {
                    str += (str === '' ? '#' : '&') + k + '=' + obj.query[k];
                }
                 obj.router && obj.router.push({ name: 'Login', query: { from: obj.routerName + str } });
            }
            if (err.response.data && ['402011'].includes(err.response.data.code)) {
                obj.router && obj.router.push({ name: 'Lock'});
            }
            !document.getElementsByClassName('el-message')[0] && Message.warning(s);
            throw err;
        });
        return api;
    },
    source: null
};
